import { IAugmentedJQuery, IDocumentService, IWindowService } from 'angular';
import {
    PopoverController,
    PopoverService,
} from '../../tn.popover/service.tn.popover';
import { IFavoriteList } from '../favorites-repository.service/favoritesRepository';
import { LocalFavorites } from '../local-favorites.service/localFavorites';
import template from './email-favorite.html';

export class EmailFavoriteController extends PopoverController {
    // bindings
    favorite?: IFavoriteList;

    //locals
    state: 'form' | 'confirmation' = 'form';
    heading = 'Email Favorite List';
    subheading = 'Please provide the email to send the list';

    sendForm: unknown;

    static $inject = [
        '$window',
        '$document',
        '$element',
        '$tnPopover',
        'localFavorites',
    ];
    constructor(
        protected $window: IWindowService,
        protected $document: IDocumentService,
        protected $element: IAugmentedJQuery,
        protected $tnPopover: PopoverService,
        protected localFavorites: LocalFavorites
    ) {
        super($window, $document, $element.children().first());
        $tnPopover.popovers.push(this);
    }

    show(anchor?: Element | EventTarget | null) {
        // reset state on show.
        this.state = 'form';
        super.show(anchor);
    }

    sendEmail(email: string) {
        const favorite = this.favorite;
        if (!favorite) {
            console.error(
                'EmailFavoriteController.sendEmail favorite is not defined'
            );
            this.hide();
            return;
        }

        if (email == undefined || email == '') {
            console.error(
                'EmailFavoriteController.sendEmail email is not defined'
            );
            return;
        }

        return this.localFavorites
            .emailFavoriteList(email, favorite.id)
            .then(() => {
                this.state = 'confirmation';
            });
        // TODO: .catch((error) => {}
    }
}

export const EmailFavoriteComponent = {
    bindings: {
        favorite: '<',
    },
    controller: EmailFavoriteController,
    template,
};
